import type { BlokProps } from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import { Container } from "@/components/ui/Container";
import type { BlokAccordionGroups } from "@/storyblok";
import styles from "./AccordionGroupsBlok.module.css";
import { AccordionGroupsContent } from "./components/AccordionGroupsContent";
import { AccordionGroupsFilterBar } from "./components/AccordionGroupsFilterBar";

export const AccordionGroupsBlok = ({
	blok,
	preview,
	insideContainer,
}: BlokProps<BlokAccordionGroups> & {
	insideContainer?: boolean;
}) => {
	if (!blok.items) return null;

	const groups = blok.items?.map((item) => item.title);

	return (
		<BlokWrap editable={blok} asChild>
			<Container>
				<div className={styles.root} data-full-width={blok.fullWidth}>
					<AccordionGroupsFilterBar groups={groups} />
					<AccordionGroupsContent items={blok.items} preview={preview} />
				</div>
			</Container>
		</BlokWrap>
	);
};
